import React, { useEffect, useState } from 'react';
import { Grid, Box, Modal, Typography, Button, LinearProgress } from "@mui/material";
import { styles } from "./styles";
import CloseIcon from '@mui/icons-material/Close';

interface successProps {
  title:string;
  open: boolean;
  //handlePopupClose: Function | any;
}


const SuccessModal: React.FC<successProps> = ({title, open, }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [err, setErr] = useState("");

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <>
        <Box sx={styles.container}>
          {isLoading && <LinearProgress sx={{ margin: ".5rem 0" }} />}
          {err !== "" && <Typography sx={{ color: "red", fontSize: ".7rem" }}>{err}</Typography>}
          <Grid item xs={12} sx={styles.header}>
            <h2>{title}</h2>
          </Grid>
          <Grid item xs={12}>
            <Typography>File Uploaded Successfully</Typography>
          </Grid>
        </Box>
      </>
    </Modal>
  )
}

export default SuccessModal;
